import React from 'react'
import { useApolloClient } from '@apollo/react-hooks'
import getQueryLots from '../graphql/Lots'
import { useState } from 'react'

const GraphQL = () => {
  const [lots, setLots] = useState(null)

  const client = useApolloClient()

  const variables = {
    start: 0,
    limit: 10,
  }

  client.watchQuery(getQueryLots(variables)).subscribe({
    next: ({ data }) => {
      if (data) {
        setLots(data.lots.values)
      }
    },
    error: (error) => {
      console.log(error)
    },
  })

  if (lots) {
    return (
      <div>
        <h4>Lots</h4>
        <ul>
          {lots.map((item, key) => (
            <li key={key}>id: {item.id}</li>
          ))}
        </ul>
      </div>
    )
  }

  return <h1>Loading</h1>
}

export default GraphQL



// WEBPACK FOOTER //
// ./src/containers/GraphQL.js